import { useShoppingCart } from 'context/ShoppingCartContext';
import { CartIcon } from '..';
import { useRouter } from 'next/navigation';
import { isMobile } from '@util/index';

const ShoppingCartButton = ({ displayCount }: { displayCount?: boolean }) => {
  const router = useRouter();
  const { getItemCount, setCartOpen } = useShoppingCart();
  const itemCount = displayCount ? getItemCount?.() : undefined;

  const handleClick = () => {
    if (!isMobile()) {
      router.push('/my-cart');
    } else {
      setCartOpen(true);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="relative flex min-w-[4.4rem] items-center justify-center text-brand-black transition-colors hover:text-brand-primary"
      aria-label="shopping-cart"
    >
      {!!itemCount && itemCount > 0 && (
        <div className="absolute -top-2 right-0 flex min-h-8 min-w-8 items-center justify-center rounded-full border-[.2rem] border-brand-white bg-brand-secondary px-2 text-[1rem] font-medium text-brand-white">
          {itemCount}
        </div>
      )}
      <CartIcon className="h-[3rem] w-[3rem] sm:h-[3.5rem] sm:w-[3.5rem]" />
    </button>
  );
};

export default ShoppingCartButton;
